var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"country-select-container"},[_c('OnSelect',{attrs:{"value":_vm.value,"options":_vm.countryOptions,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"error":_vm.error,"required":_vm.required},on:{"input":_vm.handleInput,"change":_vm.handleChange,"focus":_vm.handleFocus,"blur":_vm.handleBlur}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }